<template>
    <div class="legacy">
        <div class="search">
            <div class="search-input">
                <div class="search-container forSingle">
                    <div class="tag-default">
                        <span>{{ formatType }}</span>
                        <span class="close-btn" v-on:click="home">×</span>
                    </div>
                    <input :placeholder="$t('menu.search')" type="text" :value="query" @input="update">
                    <div class="ic-search">
                        <AtomIcSearch />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import AtomIcSearch from "../../layout/atoms/AtomIcSearch.vue";

export default {
    name: "SingleSearch",
    components: {
        AtomIcSearch
    },
    computed: {
        ...mapState('menu', {
            type: state => state.singleSearch.type,
            query: state => state.singleSearch.query,
        }),
        ...mapGetters('color', [
            'getColorForModel'
        ]),
        color: function () {
            return this.getColorForModel(this.type)
        },
        formatType() {
            if (this.type === 'event') {
                return this.$t('lowercase.events')
            } else if (this.type === 'people') {
                return this.$t('lowercase.people')
            } else if (this.type === 'project') {
                return this.$t('lowercase.project')
            } else if (this.type === 'video') {
                return this.$t('lowercase.video')
            } else if (this.type === 'partners') {
                return this.$t('lowercase.partners')
            }
        }
    },
    methods: {
        ...mapActions('menu', [
            'updateQuery'
        ]),
        home() {
            this.$router.push('/')
        },
        update(e) {
            this.updateQuery(e.target.value)
        }
    },
}
</script>
